import React from 'react';
import { IconButton, Stack } from '@mui/joy';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';


function HelpIconInfo(props) {

return (
    <Stack direction="row" >
        <IconButton size="xs" variant="plain" aria-label="Help icon"
            sx={{
                color: "#016799",
                mt: 1,
                fontSize: "15px",
                fontWeight: 400,
                "--IconButton-size": "15px",
                '&:hover': {
                    bgcolor: 'primary.plainHoverBg',
                    color: 'primary.plainColor',
                    transform: 'scale(1.07)',
                    transition: 'transform 0.5s',
                },
            }}
            onClick={() => window.open(props.link, '_blank')}>
            <ContactSupportOutlinedIcon sx={{fontSize:"17px"}} />&nbsp;{props.msg}
        </IconButton>
    </Stack>
);}
export default HelpIconInfo;